var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-main-section bgcolor-e4e9ef col-12 float-l" },
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "mobile-login-section" }),
        _vm._v(" "),
        _c("div", { staticClass: "middle-login-section bgcolor-ffffff" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "btm-login-form-main float-l width-full" }, [
            _c(
              "h2",
              {
                staticClass:
                  "color-333333 heading-text-22 line-height-26 float-l width-full center font-text-regular ucase m-0"
              },
              [_vm._v(" Sign In ")]
            ),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass:
                  "color-888888 heading-text-12 line-height-16 float-l width-full center font-text-regular"
              },
              [_vm._v(" Sign in to continue ")]
            ),
            _vm._v(" "),
            _c("form", [
              _c(
                "label",
                {
                  staticClass: "checkbox-inline checkbox-bootstrap checkbox-lg"
                },
                [
                  _vm._v("\n                          Logout from ("),
                  _c("a", { attrs: { href: _vm.ssoDomainUrl } }, [
                    _vm._v(_vm._s(_vm.ssoDomainUrl))
                  ]),
                  _vm._v(
                    "),If You are not able to login please clear Cookies and login again.\n                          Please contact admin if you are still not able to Login.\n                      "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btm-page-link float-r width-full" },
              [
                _c(
                  "router-link",
                  {
                    staticClass:
                      "color-6d6e70 heading-text-14 line-height-18 font-regular right float-r",
                    attrs: { to: { name: "PrivacyPolicy" } }
                  },
                  [_vm._v(" Privacy Policy ")]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "vvg-logo-img width-full float-l" }, [
      _c("div", { staticClass: "vvg-logo-internal" }, [
        _c("img", {
          attrs: {
            src: "/static/images/login-logo-small.png",
            alt: "Chat Logo"
          }
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-657094ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-657094ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/Login.vue
// module id = null
// module chunks = 